import { DateTime } from "luxon";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";
import type { CustomPrintoutVersionSummary } from "./customPrintoutTypes";
import { versionSavedAtLabel } from "./customPrintoutVersionLabels";
import { useCustomPrintoutAuthorLabel } from "./useCustomPrintoutAuthorLabel";

/** Who saved a version and when, as one line — "Dana Levi · Today, 3:14 PM" — in the department's time zone. */
export const useCustomPrintoutVersionMeta = () => {
	const { t, i18n } = useTranslation();
	const { timezone } = useHospitalData();
	const authorLabel = useCustomPrintoutAuthorLabel();
	return useCallback(
		(version: CustomPrintoutVersionSummary): string =>
			t("printout.custom.ai.version.meta", {
				author: authorLabel(version.author),
				when: versionSavedAtLabel({ createdAt: version.createdAt, now: DateTime.now(), timezone, locale: i18n.language, t }),
			}),
		[t, i18n.language, timezone, authorLabel],
	);
};
